import React, { Component } from 'react'

export class Footer extends Component {
    render() {
        return (
            <footer class="footer widget-footer bg-base-dark clearfix">
                <div class="second-footer">
                    <div class="container">
                        <div class="row no-gutters">
                            <div class="col-xl-4 col-lg-6 col-md-6">
                                <div class="footer-widget-box first-child">
                                    <h3 class="widget-title-h3">Subscribe now!</h3>
                                    <div class="form-block">
                                        <div class="widget-form">
                                            <form id="subscribe-form" class="newsletter-form" method="post" action="#" data-mailchimp="true">
                                                <div class="mailchimp-inputbox clearfix" id="subscribe-content">
                                                    <p class="mb-0">
                                                        <input type="email" name="email" placeholder="Your email" required="" />
                                                    </p>
                                                    <button class="submit" type="submit">Send Now<i class="fas fa-long-arrow-alt-up"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <h3 class="widget-title-h3">Our Location:</h3>
                                    <div class="ttm-iconbox">
                                        <div class="footer-icon">
                                          <div class="footer-icon-box">
                                            <div class="footer-icon-link"><i class="ti ti-location-pin"></i></div>
                                          </div>
                                          <div class="footer-box-content">
                                            <p class="mb-0">Schweizer Skischule lohnerhubels Mtrasse 95 CH-3123 Belp</p>
                                          </div>
                                        </div>
                                    </div>
                                    <div class="footer-social-links-wrapper">
                                        <ul class="footer-social-icons">
                                            <li class="footer-social-icons-item">
                                                <a href="https://www.facebook.com/people/@/templatetechMount18" class="footer-social-icons-link">Facebook</a>
                                            </li>
                                            <li class="footer-social-icons-item">
                                                <a href="https://twitter.com/templatetechmount" class="footer-social-icons-link">Twitter</a>
                                            </li>
                                            <li class="footer-social-icons-item">
                                                <a href="https://www.instagram.com/template_tech_mount/" class="footer-social-icons-link">Instagram</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6">
                                <div class="footer-widget-box res-767-pt-45">
                                    <h3 class="widget-title-h3">Quick Links</h3>
                                    <div class="footer-menu-links">
                                        <ul class="footer-menu-list">
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Make Appointment</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Free Consultation</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Department</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">About Company</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Our Case Studies</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Free Consultation</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Meet Our Experts</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Business Growth</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">IT Management</a>
                                            </li>
                                            <li class="footer-menu-item">
                                                <a href="#" class="footer-menu-item-link">Software Dev</a>
                                            </li>
                                            <li class="footer-menu-item last-child">
                                                <a href="#" class="footer-menu-item-link">Our Case Studies</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6">
                                <div class="footer-widget-box last-child res-767-pt-25">
                                    <div class="widget_nav_menu">
                                        <div class="textwidget-widget-text">
                                            <div class="ttm-numbertext">
                                                <p class="ttm-numbertext-p">Our phone number</p>
                                                <h3 class="ttm-numbertext-h3">
                                                  <a href="tel:+123456789" class="ttm-numbertext-link">+1800 123 456789 99</a>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ttm-horizontal_sep mb-45 mt-25 res-991-mt-10 res-991-mb-25"></div>
                                    <div class="widget_nav_menu">
                                        <div class="textwidget-widget-text">
                                            <div class="ttm-numbertext">
                                                <p class="ttm-numbertext-p">Our email address</p>
                                                <h3 class="ttm-numbertext-h3">
                                                  <a href="mailto:contact@company.com" class="ttm-numbertext-link">altech123@gmail.com</a>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ttm-horizontal_sep mb-40 mt-25 res-991-mt-10 res-991-mb-25"></div>
                                    <div class="widget_nav_menu">
                                        <div class="textwidget-widget-text">
                                            <div class="ttm-numbertext">
                                                <p class="ttm-numbertext-p">Copyright © 2023 <a href="https://altech-demo.preyantechnosys.com/adv" class="ttm-numbertext-p-link">Altech Advanced</a> template</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </footer>
        )
    }
}